import { snakeCase, camelCase } from 'lodash';
import { uploadFile } from '@/server/common';
import SparkMD5 from 'spark-md5';

// eslint-disable-next-line no-undef
export const isI18n = ZONE === 'sg';

/* eslint-disable no-param-reassign,no-restricted-syntax */

export function camleToSnake(obj: any, noChangeKey: string[] = []) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    if (obj[0] && typeof obj[0] === 'object') {
      for (let i = 0; i < obj.length; i += 1) {
        obj[i] = camleToSnake(obj[i], noChangeKey);
      }
    }
    return obj;
  }
  for (const key of Object.keys(obj)) {
    if (!noChangeKey.includes(key)) {
      let newKey = snakeCase(key);
      if (/^-?[1-9]\d*$/g.test(key)) {
        newKey = key;
      }
      obj[newKey] = camleToSnake(obj[key], noChangeKey);
      if (newKey !== key) {
        delete obj[key];
      }
    }
  }
  return obj;
}

export function snakeToCamle(obj: any, noChangeKey: string[] = []) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    if (obj[0] && typeof obj[0] === 'object') {
      for (let i = 0; i < obj.length; i += 1) {
        obj[i] = snakeToCamle(obj[i], noChangeKey);
      }
    }
    return obj;
  }
  for (const key of Object.keys(obj)) {
    if (!noChangeKey.includes(key)) {
      let newKey = camelCase(key);
      if (/^-?[1-9]\d*$/g.test(key)) {
        newKey = key;
      }
      obj[newKey] = snakeToCamle(obj[key], noChangeKey);
      if (newKey !== key) {
        delete obj[key];
      }
    }
  }
  return obj;
}

export function uploadImage(file: any, callback: Function) {
  const formData = new FormData();
  formData.append('upload_type', 'IMAGE');
  formData.append('file', file);

  const fileReader = new FileReader();
  const spark = new SparkMD5(); // 创建md5对象（基于SparkMD5）
  fileReader.readAsBinaryString(file);

  // 文件读取完毕之后的处理
  fileReader.onload = async function load(e: any) {
    spark.appendBinary(e.target.result);
    const md5 = spark.end();
    formData.append('file_signature', md5);
    const result: any = await uploadFile(formData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    callback && callback(result.data);
  };
}

export function validateImage(file: any) {
  return new Promise((resolve) => {
    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
      resolve('type_limit');
    }

    if (file.size > 1024 * 1000) {
      resolve('size_limit');
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = () => {
        resolve(image.width / image.height === 1 ? 'success' : 'range_limit');
      };
    };
  });
}

export function getQueryParams(variable: string) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return undefined;
}

export function isInputEmpty(str: string) {
  if (!str) return true;
  return /^[ ]+$/.test(str);
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent);
}

export function dataURLtoBlob(dataurl: string) {
  const arr = dataurl.split(',');
  const mime = (arr as any)[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export function blobToFile(theBlob: any, fileName: string) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
}
